import * as React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { Col, Container, Row, config, Hidden, Visible } from 'react-awesome-styled-grid'
import { Carousel } from '@components/home/Carousel'
import { CTAPrimary } from '@components/shared/buttons'
import { colors } from '@components/shared/colors'
import { GoodSansB2, QueensH2 } from '@components/shared/typography'
import type { HeaderSectionPropsType } from '../HeaderSection'
import type { AppStateType } from '../../reducers/appstate'
import FadeInContent from '@components/shared/FadeInContent'
import { TagPillRow } from '@components/Tag/TagPillRow'

export default function HeaderLayout1 (props: HeaderSectionPropsType & { openSubscribe: () => void }): React.ReactNode {
  const isSubscribed = useSelector((state: AppStateType): boolean => !!(state.user || {}).isSubscribed)
  return (
    <Layout>
      <FadeInContent>
        <Carousel isCoverflow />
      </FadeInContent>
      <Container>
        <Row>
          <Col>
            <FadeInContent>
              <HeaderTextContainer>
                <HeaderText>{props.title}</HeaderText>

                {props.tags && <TagContainer><TagPillRow id={props.title} small tags={props.tags} /></TagContainer>}

                <Hidden xs={true} sm={true}>
                  <Description>{props.description}</Description>
                </Hidden>
                <Visible xs={true} sm={true}>
                  <Description>{props.description2}</Description>
                </Visible>

                {!isSubscribed && <CTAPrimary onClick={props.openSubscribe} className={'subscribe-cta'}>{props.ctaText}</CTAPrimary>}
              </HeaderTextContainer>
            </FadeInContent>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}
const TagContainer = styled.div<any>`
  display: flex;
  .TagPillRow {
    justify-content: center;
    div, a {
      border-color: ${colors.sand};
      color: ${colors.sand};
    }
  }
`
const Layout = styled.div<any>`
  padding: 0px 0 30px;
  ${(props: any): any => config(props).media.md`
    padding: 0 0 60px;
  `}
  ${(props: any): any => config(props).media.lg`
    padding: 0 0 90px;
  `}
`
const HeaderTextContainer = styled.div<any>`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  h1,
  p,
  div {
    text-align: center;
  }
`
const HeaderText = styled.h1<any>`
  ${QueensH2};
  color: ${colors.sand};
`
const Description = styled.p<any>`
  ${GoodSansB2};
  color: ${colors.sand};
  margin: 0 0 1em;
  max-width: 900px;
`
